import { render, staticRenderFns } from "./UserTabGlwsses.vue?vue&type=template&id=c0b7e52e"
import script from "./UserTabGlwsses.vue?vue&type=script&lang=js"
export * from "./UserTabGlwsses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports